import { createSelector } from 'reselect';

const selectRaw = (state) => state.layout;

const selectMenuVisible = createSelector(
  [selectRaw],
  (layout) => Boolean(layout.menuVisible),
);

const selectDarkMode = createSelector(
  [selectRaw],
  (layout) => Boolean(layout.darkMode),
);

const selectLoading = createSelector(
  [selectRaw],
  (layout) => Boolean(layout.loading),
);

const selectLanguage = createSelector(
  [selectRaw],
  (layout) => layout.language,
);

const selectFullPageLoading = createSelector(
  [selectRaw],
  (layout) => Boolean(layout.fullPageLoading),
);

const layoutSelectors = {
  selectRaw,
  selectMenuVisible,
  selectLoading,
  selectLanguage,
  selectDarkMode,
  selectFullPageLoading,
};

export default layoutSelectors;
